import { useState } from "react";
import { motion } from "framer-motion";
import { Gift, Sparkles } from "lucide-react";
import { FounderModal } from "./FounderModal";

const EASE = [0.16, 1, 0.3, 1];

export const FounderCampaign = () => {
  const [open, setOpen] = useState(false);

  return (
    <section className="relative mx-auto max-w-6xl px-6 py-20" data-testid="founder-campaign">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.9, ease: EASE }}
        className="relative overflow-hidden rounded-[2rem] border border-white/10 bg-gradient-to-br from-white/[0.06] to-white/[0.02] p-8 text-center backdrop-blur-xl sm:p-14"
      >
        {/* gold + tricolour glow */}
        <div className="pointer-events-none absolute -top-24 left-1/2 h-64 w-[36rem] -translate-x-1/2 rounded-full bg-[radial-gradient(circle,rgba(255,196,0,0.25),transparent_70%)] blur-2xl" />
        <div className="pointer-events-none absolute -bottom-20 right-0 h-56 w-56 rounded-full bg-indril-green/10 blur-3xl" />

        <motion.div
          initial={{ scale: 0.6, rotate: -8, opacity: 0 }}
          whileInView={{ scale: 1, rotate: 0, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: EASE, delay: 0.1 }}
          className="relative mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-3xl bg-gradient-to-br from-amber-300 to-indril-saffron text-zinc-950 shadow-[0_10px_50px_-8px_rgba(255,180,0,0.6)] animate-float-y"
        >
          <Gift className="h-9 w-9" />
          <Sparkles className="absolute -right-2 -top-2 h-5 w-5 text-amber-200" />
        </motion.div>

        <p className="mb-3 inline-flex items-center gap-2 rounded-full border border-amber-300/30 bg-amber-300/10 px-4 py-1.5 text-xs uppercase tracking-[0.2em] text-amber-200">
          A Surprise Awaits You
        </p>
        <h2 className="mx-auto max-w-2xl font-display text-3xl font-semibold tracking-tight text-white sm:text-4xl">
          Become one of the first <span className="text-tricolor">10,000</span> approved Founder Creators of IND RIL.
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-white/55">
          A special surprise is reserved for our earliest creators. Claim your spot now — the full reveal awaits inside.
        </p>

        <button
          onClick={() => setOpen(true)}
          data-testid="founder-cta"
          className="mt-8 inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-amber-300 to-indril-saffron px-8 py-4 font-display text-lg font-semibold text-zinc-950 transition-transform hover:scale-[1.03]"
        >
          <Gift className="h-5 w-5" /> Claim Your Founder Spot
        </button>

        <p className="mx-auto mt-6 max-w-2xl text-xs leading-relaxed text-white/40">
          The Founder Creator Badge will be activated only after the campaign reaches 10,000 verified and approved
          registrations and the final eligibility review is completed. Registration does not guarantee approval.
        </p>
      </motion.div>

      <FounderModal open={open} onOpenChange={setOpen} />
    </section>
  );
};
